import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { BerthSelectBox } from "@/components/uis/AssessmentReadyHeader/uis/berthSelectBox";
import { IconLabelSelector } from "@/components/uis/IconLabelSelector";
import { SideBarIcon } from "@/components/uis/SideBarIcon";
import { useContainer } from "./hooks/container";
import styles from "./styles.module.css";
import { PeriodSelectBox, type SummaryPeriod } from "./uis/periodSelectBox";
export type { SummaryPeriod };
type AssessmentReadyHeaderProps = {
  factoryId: string;
  unloadingDockName: string;
  selectedBerth?: string;
  onChangeBerth?: (value: string) => void;
  cameraName?: string;
  selectedPeriod?: SummaryPeriod;
  onChangePeriod?: (period: SummaryPeriod) => void;
};

/**
 * /, /cameras, /assessment/confirmのヘッダー
 * 検収のステータス表示と担当者、バースの選択を行う
 */
export const AssessmentReadyHeader: FC<AssessmentReadyHeaderProps> = t0 => {
  const $ = _c(18);
  const {
    factoryId,
    unloadingDockName,
    selectedBerth,
    onChangeBerth,
    cameraName,
    selectedPeriod,
    onChangePeriod
  } = t0;
  let t1;
  if ($[0] !== onChangeBerth) {
    t1 = {
      onChangeBerth
    };
    $[0] = onChangeBerth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleChangeBerth
  } = useContainer(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SideBarIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== factoryId || $[4] !== handleChangeBerth || $[5] !== onChangeBerth || $[6] !== selectedBerth || $[7] !== unloadingDockName) {
    t3 = onChangeBerth && selectedBerth ? <BerthSelectBox factoryId={factoryId} selectedBerth={selectedBerth} handleChange={handleChangeBerth} /> : <Box display="flex" alignItems="center" gap="8px"><IconLabelSelector type="berth" iconColor="primary" /><Typography variant="h4" component="div">{unloadingDockName}</Typography></Box>;
    $[3] = factoryId;
    $[4] = handleChangeBerth;
    $[5] = onChangeBerth;
    $[6] = selectedBerth;
    $[7] = unloadingDockName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onChangePeriod || $[10] !== selectedPeriod) {
    t4 = onChangePeriod && selectedPeriod !== undefined && <PeriodSelectBox selectedPeriod={selectedPeriod} onChangePeriod={onChangePeriod} />;
    $[9] = onChangePeriod;
    $[10] = selectedPeriod;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== cameraName) {
    t5 = cameraName && <Box display="flex" alignItems="center" gap="8px"><IconLabelSelector type="camera" iconColor="primary" /><Typography variant="h4" component="div">{cameraName}</Typography></Box>;
    $[12] = cameraName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <AppBar position="static" className={styles.appBar}><Box display="flex" alignItems="flex-end" gap="24px">{t2}<Box pb="4px" display="flex" alignItems="center" gap="16px">{t3}{t4}{t5}</Box></Box></AppBar>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};